import { render, staticRenderFns } from "./change-password-dialog.vue?vue&type=template&id=28a5820c"
import script from "./change-password-dialog.vue?vue&type=script&lang=js"
export * from "./change-password-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports